import { css } from 'styled-components';
import { colors } from './colors';

// Типы устройств
export enum DeviceType {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}

// Интерфейс для стилей типографики
export interface TypographyStyle {
  fontSize: string;
  lineHeight: string;
  fontWeight: number;
  letterSpacing?: string;
  color?: string;
}

// Типы текста
export enum TextType {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  SUBTITLE1 = 'subtitle1',
  SUBTITLE2 = 'subtitle2',
  TEXT_LARGE = 'textLarge',
  TEXT_MEDIUM = 'textMedium',
  TEXT_SMALL = 'textSmall',
}

// Стили для мобильных устройств
const mobileStyles: Record<TextType, TypographyStyle> = {
  [TextType.H1]: {
    fontSize: '48px',
    lineHeight: '100%',
    fontWeight: 600,
  },
  [TextType.H2]: {
    fontSize: '40px',
    lineHeight: '100%',
    fontWeight: 700,
  },
  [TextType.H3]: {
    fontSize: '34px',
    lineHeight: '110%',
    fontWeight: 600,
  },
  [TextType.H4]: {
    fontSize: '26px',
    lineHeight: '100%',
    fontWeight: 600,
  },
  [TextType.SUBTITLE1]: {
    fontSize: '22px',
    lineHeight: '100%',
    fontWeight: 600,
  },
  [TextType.SUBTITLE2]: {
    fontSize: '19px',
    lineHeight: '120%',
    fontWeight: 600,
  },
  [TextType.TEXT_LARGE]: {
    fontSize: '18px',
    lineHeight: '140%',
    fontWeight: 400,
    color: colors.accentQuaternary6
  },
  [TextType.TEXT_MEDIUM]: {
    fontSize: '16px',
    lineHeight: '140%',
    fontWeight: 400,
    color: colors.accentQuaternary6
  },
  [TextType.TEXT_SMALL]: {
    fontSize: '14px',
    lineHeight: '140%',
    fontWeight: 400,
    color: colors.accentQuaternary6
  },
};

// Стили для десктопных устройств
const desktopStyles: Record<TextType, TypographyStyle> = {
  [TextType.H1]: {
    fontSize: '64px',
    lineHeight: '100%',
    fontWeight: 600,
  },
  [TextType.H2]: {
    fontSize: '56px',
    lineHeight: '100%',
    fontWeight: 600,
  },
  [TextType.H3]: {
    fontSize: '48px',
    lineHeight: '100%',
    fontWeight: 600,
  },
  [TextType.H4]: {
    fontSize: '40px',
    lineHeight: '100%',
    fontWeight: 600,
  },
  [TextType.SUBTITLE1]: {
    fontSize: '32px',
    lineHeight: '110%',
    fontWeight: 600,
  },
  [TextType.SUBTITLE2]: {
    fontSize: '22px',
    lineHeight: '120%',
    fontWeight: 600,
  },
  [TextType.TEXT_LARGE]: {
    fontSize: '18px',
    lineHeight: '140%',
    fontWeight: 400,
    color: colors.accentQuaternary6
  },
  [TextType.TEXT_MEDIUM]: {
    fontSize: '16px',
    lineHeight: '140%',
    fontWeight: 400,
    color: colors.accentQuaternary6
  },
  [TextType.TEXT_SMALL]: {
    fontSize: '14px',
    lineHeight: '140%',
    fontWeight: 400,
    color: colors.accentQuaternary6
  },
};

// Получение стилей в зависимости от типа устройства
export const getTypographyStyle = (textType: TextType, deviceType: DeviceType = DeviceType.DESKTOP): TypographyStyle => {
  return deviceType === DeviceType.MOBILE ? mobileStyles[textType] : desktopStyles[textType];
};

// CSS-хелпер для применения стилей типографики
export const applyTypography = (textType: TextType, deviceType: DeviceType = DeviceType.DESKTOP) => {
  const style = getTypographyStyle(textType, deviceType);

  return css`
    font-size: ${style.fontSize};
    line-height: ${style.lineHeight};
    font-weight: ${style.fontWeight};
    color: ${style.color};
    ${style.letterSpacing ? `letter-spacing: ${style.letterSpacing};` : ''}
  `;
};

// Медиа-запросы для адаптивности
export const media = {
  mobile: '@media (max-width: 1024px)',
//   tablet: '@media (min-width: 768px) and (max-width: 1023px)',
  desktop: '@media (min-width: 1024px)',
};
